import React from 'react'
import { connect } from 'react-redux'

import {
  getCommitment,
  getProviderSelectOptions,
  getRepaymentTypeSelectOptions,
  getRepaymentWaysTypeSelectOptions,
  getLoanApplication,
} from './../../../../reducers'

import {
  commitmentChanged,
} from '../../../../actions'

import Header from './Header'

// Commitments forms based on commitment TYPE
import HomeLoan from './Form/HomeLoan'
import Credit from './Form/Credit'
import Loan from './Form/Loan'
import EducationalLoan from './Form/EducationalLoan'
import Other from './Form/Other'

class Commitment extends React.Component {

  getAttributeFromOption(attribute) {
    const { availableCommitments, commitment } = this.props
    return availableCommitments[commitment.option][attribute]
  }

  onChange = (params) => {
    let { commitment, commitmentChanged } = this.props
    this.props.resetValidation()
    this.props.commitmentChanged({
      ...{ key: commitment.key },
      ...params
    })
  }

  mapOwnerOptions = () => {
    const { primaryApplicantName, secondaryApplicantName } = this.props.loanApplication;

    if (!secondaryApplicantName) {
      return [];
    }

    return [
      {
        label: primaryApplicantName,
        value: primaryApplicantName
      },
      {
        label: secondaryApplicantName,
        value: secondaryApplicantName
      },
      {
        label: 'Joint',
        value: 'Joint'
      }
    ]
  }

  renderForm() {
    const {
      commitment,
      availableProviders,
      availableRepaymentTypeOptions,
      availableRepaymentWays
    } = this.props

    const { option } = this.props.commitment
    const ownerOptions = this.mapOwnerOptions();

    switch(option) {
      case 'home_loan':
        return(
          <HomeLoan
            commitment={ commitment }
            availableProviders={ availableProviders }
            availableRepaymentTypeOptions={ availableRepaymentTypeOptions }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'line_of_credit':
        return(
          <Credit
            commitment={ commitment }
            availableProviders={ availableProviders }
            availableRepaymentWays={ availableRepaymentWays }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'credit_card':
        return(
          <Credit
            commitment={ commitment }
            availableProviders={ availableProviders }
            availableRepaymentWays={ availableRepaymentWays }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'personal_loan':
        return(
          <Loan
            commitment={ commitment }
            availableProviders={ availableProviders }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'car_loan':
        return(
          <Loan
            commitment={ commitment }
            availableProviders={ availableProviders }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'post_payment_facility':
        return(
          <Credit
            commitment={ commitment }
            availableProviders={ availableProviders }
            availableRepaymentWays={ availableRepaymentWays }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'educational_loan':
        return(
          <EducationalLoan
            commitment={ commitment }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      case 'other':
        return(
          <Other
            commitment={ commitment }
            onChange = { this.onChange }
            ownerOptions={ ownerOptions }
          />
        )
      default:
        return null
    }
  }

  render() {
    const { id } = this.props
    const { _destroy } = this.props.commitment
    const collapsableId = `commitment${id}`

    // Let's hide this if it's marked for destruction!
    if (_destroy) {
      return(null)
    }

    return(
      <div>
        <div className='card card-border card-collapse select-commitment-form mb-0'>
          <Header
            collapsableId={ collapsableId }
            title={ this.getAttributeFromOption('title') }
            iconName={ this.getAttributeFromOption('icon_name') }
          />
          <div className='collapse multi-collapse show' id={ collapsableId } >
            { this.renderForm() }
          </div>
        </div>
        <div className='text-right'>
          <div
            className='pointer smaller grey mb-3'
            onClick={ () => { this.onChange({'_destroy': 1}) } }
          >
            Remove
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const commitment = getCommitment(state, ownProps.id)

  return {
    commitment: commitment,
    availableProviders: getProviderSelectOptions(state, commitment.option),
    availableRepaymentTypeOptions: getRepaymentTypeSelectOptions(state, commitment.option),
    availableRepaymentWays: getRepaymentWaysTypeSelectOptions(state, commitment.option),
    loanApplication: getLoanApplication(state),
  }
}

export default connect(mapStateToProps, {
  commitmentChanged
})(Commitment)
